<script lang="ts">
  import { onMount } from "svelte";
  import { base } from "$app/paths";
  import NoExtendIcon from "../icons/NoExtendIcon.svelte"
  import ExtendIcon from "../icons/ExtendIcon.svelte"

  export let title = "";
  export let content = "";
  export let isOpen = true;

  // 控制动画状态
  let isAnimating = false;
  let height = 0;
  let contentElement: any;

  function toggle() {
    if (isAnimating || !contentElement) return;

    isAnimating = true;
    height = contentElement.scrollHeight;
    isOpen = !isOpen;
    setTimeout(() => (isAnimating = false), 300);
  }

  onMount(() => {
    // 初始化时设置高度
    if (contentElement) {
      setTimeout(() => {
        height = contentElement.scrollHeight;
      }, 0);
    }
  });
</script>

<div class="mb-6 overflow-hidden w-full max-mobile:mb-5">
  <!-- 标题区域 -->
  <div
    class="rounded-[12px] p-6 cursor-pointer flex items-center hover:bg-gray-50 transition-colors bg-white
    max-mobile:rounded-[8px] max-mobile:p-4 max-mobile:flex-row-reverse
    "
    on:click={toggle}
    aria-hidden="true"
  >
    <div class="transition-transform duration-300 flex-shrink-0">
    <div  class="w-6 h-6 mr-5 max-mobile:w-5 max-mobile:h-5 max-mobile:ml-4 max-mobile:mr-0">
         <svelte:component this={isOpen?NoExtendIcon:ExtendIcon} />
    </div>
      <!-- <img
        src={base + (isOpen ? "/icons/close-icon.png" : "/icons/open-icon.png")}
       
        alt="close"
      /> -->
    </div>
    <h3
      class="flex items-center !font-bold !text-[22px] !leading-[1.5] text-[#111111] max-mobile:!text-[16px] max-mobile:mr-auto"
    >
      {title}
    </h3>
  </div>
  <!-- 内容区域 -->
  <div
    bind:this={contentElement}
    class="max-h-0 overflow-hidden transition-all duration-300 ease-in-out"
    style="max-height: {isOpen ? `${height}px` : 0}; opacity: {isOpen ? 1 : 0}"
  >
    <p
      class="px-6 pt-6 pb-3 text-[18px] leading-[1.5] whitespace-pre-wrap max-mobile:text-[16px] max-mobile:px-2 max-mobile:pt-2 max-mobile:pb-1"
    >
      {content}
    </p>
  </div>
</div>
